import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Konto',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Administrer konto',
      description: 'Hold din konto opdateret, og administrer dine indstillinger.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Betalingsmetoder',
      description: 'Tilføj, skift eller vælg din foretrukne betalingsmetode.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Hjælp og FAQ',
    },
    [AccountItemEnum.Logout]: {
      title: 'Log ud',
    },
    [AccountItemEnum.Language]: {
      title: 'Sprog',
    },
  },
};
